import axios from 'axios';
import { useCallback } from 'react';

import { configSetting } from '../config';
import { HttpConfig } from '../models/https';

const useHttps = () => {
  const sendRequest = useCallback(
    async (
      httpConfig: HttpConfig,
      callback: (data: any) => void,
      loadingFunc?: (value: boolean) => void,
      errorFunc?: (err: any) => void
    ): Promise<void> => {
      const apiUrl = `${configSetting.apiUrl}${httpConfig.url}`;

      const config = {
        ...httpConfig,
        url: apiUrl,
        headers: {
          // Only set Content-Type to application/json if data is not FormData
          ...(!(httpConfig.data instanceof FormData) && {
            'Content-Type': 'application/json',
          }),
          ...httpConfig.headers,
        },
      };

      try {
        if (loadingFunc) {
          loadingFunc(true);
        }

        const response = await axios(config);
        callback(response.data);
      } catch (err: any) {
        if (errorFunc) {
          errorFunc(err);
        }
      } finally {
        if (loadingFunc) {
          loadingFunc(false);
        }
      }
    },
    []
  );

  return sendRequest;
};

export default useHttps;
